import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "news__item-card-image column justify-between" }
const _hoisted_2 = { class: "news__item-card-image_top" }
const _hoisted_3 = { class: "col-xs-12 title" }
const _hoisted_4 = { class: "col-xs-12 description" }
const _hoisted_5 = {
  key: 0,
  class: "col-xs-12 news__date row items-center"
}
const _hoisted_6 = { class: "s-pb-xs" }
const _hoisted_7 = { class: "col-xs-12" }
const _hoisted_8 = { class: "col-xs-12 news__date row items-center" }
const _hoisted_9 = { class: "s-pr-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_s_icon = _resolveComponent("s-icon")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: _ctx.goToNews()
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.getNewsName), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getNewsDescription), 1),
      (_ctx.getNewsSource)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.getNewsSource), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_q_img, {
          class: "image",
          src: _ctx.getImage(_ctx.news.imageId, _ctx.news.id),
          alt: "Изображение новости",
          onError: _ctx.imageNotLoading
        }, null, 8, ["src", "onError"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_s_icon, {
          name: "app:date",
          size: "middle",
          class: "s-mr-sm not-hovered"
        }),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getNewsDate), 1)
      ])
    ])
  ], 512)), [
    [_vShow, !_ctx.isLoading]
  ])
}